import React,{ useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import {
    Container,
    ScreenClassRender
} from "react-grid-system";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import GenericUpper from "../../components/generic-upper";
import { UserContainer } from "./styles";
import Select from "../../components/select/select_v2";
import Input from "../../components/input/input_v2";
import Button from "../../components/button/button_v2";
import { store } from "react-notifications-component";

import Modal from "../../components/modal";
import ModalLoja from "../../components/modal/modalAddLoja";
import ModalAlert from '../../components/modal/modalGeneric';

import PeapleWarning from '../../assets/undraw-warning.svg';

import * as S from './styles'
import { theme } from "../../styles/theme";
import { BodyG, H5 } from "../../styles/stylesTypography";

export const USER = "@userinfo";


const AddUsuario = ({ ...props }) => {

    const [permissoes, setPermissoes] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [permissaoId, setPermissaoId] = useState('');
    const [email, setEmail] = useState('');
    const [nome, setNome] = useState('');
    const [lojaId, setLojaId] = useState('');
    const [showModalLoja, setShowModalLoja] = useState(false);
    const [loading, setLoading] = useState(false);

    const [erroPermisao, setErroPermissao] = useState(false);
    const [erroNome, setErroNome] = useState(false);
    const [erroEmail, setErroEmail] = useState(false);
    const [erroLoja, setErroLoja] = useState(false);

    const [whatsapp, setWhatsapp] = useState('');
    const [erroWhatsapp, setErroWhatsapp] = useState(false);

    const [showDisabledCad, setShowDisabledCad] = useState(false);

    const [openModalAlert, setOpenModalAlert] = useState(false);
    const [mensagemModalAlert, setMensagemModalAlert] = useState('');

    const getFiliais = useCallback(async () => {
        try {
            let inputWithErrors = document.querySelectorAll(".error");

            for (let input of inputWithErrors) {
                input.classList.remove("error");
            }

            const response = await api.get(`/filiais`);
            const filiais = response.data.data;

            if (filiais && filiais.length > 0) {
                const filialFormat = (filiais || []).map(f => ({ value: f.id, label: f.nome_fantasia }));
                setLojas(filialFormat);

            } else {
                setLojas([]);
            }
        } catch (e) {
            setLojas([]);

            const input = document.getElementById('agro_subsidiary_id');
            input.classList.add("error");


            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(e),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }, []);

    const validatePermissao = async (permissao) => {
        setPermissaoId(permissao.value);
        setErroPermissao(false);
    }

    const validateEmail = async (email) => {
        setEmail(email);
        setErroEmail(false);
    }

    const validateName = async (nome) => {
        setNome(nome);

        setErroNome(false);
    }

    const validateWhatsapp = async (whatsapp) => {
        const numeroLimpo = whatsapp.replace(/\D/g, '');
        
        let numeroFormatado = '';
        
        if (numeroLimpo.length <= 10) {
            numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1)$2-$3');
        } else {
            numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1)$2-$3');
        }
        
        if (numeroLimpo.length < 10) {
            if (numeroLimpo.length <= 2) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2}).*/, '($1)');
            } else if (numeroLimpo.length <= 6) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{0,4}).*/, '($1)$2');
            } else if (numeroLimpo.length <= 10) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1)$2-$3');
            }
        }
        
        setWhatsapp(numeroFormatado);
        setErroWhatsapp(false);
    }

    const validateLoja = async (loja) => {
        setLojaId(loja.value);
        setErroLoja(false);
    }

    const salvarUser = async () => {
        if (whatsapp && (whatsapp.replace(/\D/g, '').length < 10 || whatsapp.replace(/\D/g, '').length > 11)) {
            setErroWhatsapp(true);
            return;
        }

        setLoading(true);

        try {
            const payload = {
                agro_permission_id: permissaoId,
                username: email,
                agro_subsidiary_id: lojaId ? lojaId : '',
                status: 'AT',
                name: nome,
                whatsapp,
                enviar_receita: 1
            }
            await api.post(`/users`, payload);

            props.history.push('/usuarios');
            setLoading(false);
            
        } catch (err) {
            setLoading(false);

            const ERRO = err.response.data.errors;

            if (ERRO) {
                if (ERRO === 'O limite de licenças para esse contrato foi atingido!') {
                    setShowDisabledCad(true)
                } else {
                    if (err.response.status !== 422) {
                       store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(err, ERRO),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }
                }
            } else {
                if (permissaoId === '') {
                    setErroPermissao(true);
                }

                if (email === '') {
                    setErroEmail(true);
                }

                if (lojaId === '') {
                    setErroLoja(true);
                }

                if (nome === '') {
                    setErroNome(true);
                }

                if (whatsapp.replace(/\D/g, '').length < 10 || whatsapp.replace(/\D/g, '').length > 11) {
                    setErroWhatsapp(true);
                }
            
                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

            if (err.response.status === 422) {
                setOpenModalAlert(true);
                setMensagemModalAlert(err.response.data.errors);

                setErroEmail(true);
            }
        }
    }

    const updateLoja = async e => {
        getFiliais();
    }

    const validaEmail = async () => {}


    const getPermission = useCallback(async () => {
        const response = await api.get(`/users/nivel/permissao`);

        let v = response.data.data.nivel;
        const next = [];

        if (v[0] && typeof v[0] === 'object') {
            for (const [key, value] of Object.entries(v[0])) {
                next.push({
                    value: parseInt(key),
                    label: value
                });
            }

            for (let i = 1; i < v.length; i++) {
                if (v[i] && v[i].value !== undefined) {
                    next.push(v[i]);
                }
            }
        } else {
            v[1] = {
                value: 1,
                label: v[1]
            }

            v[2] = {
                value: 2,
                label: v[2]
            }

            v[3] = {
                value: 3,
                label: v[3]
            }

            for (let i in v) {
                next.push(v[i]);
            }
        }

        const descricoesPermissao = {
            1: 'Acesso total ao sistema.',
            2: 'Acesso restrito à sua filial.',
            3: 'Acesso operacional. Focado na emissão de receitas e consulta de solicitações. Visualiza apenas os dados da própria filial.',
        };
        const nextComDescricao = next.map(op => ({
            ...op,
            description: descricoesPermissao[op.value] || undefined,
        }));

        setPermissoes(nextComDescricao);
    }, []);

    useEffect(() => {
        getPermission();
        getFiliais();
    }, [getPermission, getFiliais]);


    const openModalLoja = async () => {
        setShowModalLoja(true);
    }

    const closeModal = async () => {
        setShowModalLoja(false);
    }

    return(
        <ScreenClassRender
            render={screenClass => (
                <>
                    <GenericUpper
                        title="Cadastrar usuários"
                        subtitle="Gerencie seus usuários"
                    ></GenericUpper>

                    <UserContainer>
                        <Container>
                            <div className="container-center">

                                <Select
                                    label="Permissão"
                                    labelWithAsterisk={true}
                                    options={permissoes}
                                    id="agro_permission_id"
                                    onChange={e => validatePermissao(e)}
                                    erro={erroPermisao}
                                    marginBottom="46px"
                                    height="auto"
                                />

                                <Input 
                                    label="Nome"
                                    labelWithAsterisk={true}
                                    type="text"
                                    id="name_id"
                                    onChange={e => validateName(e)}
                                    erro={erroNome}
                                    marginBottom="32px"
                                    height="auto"
                                />

                                <Input 
                                    label="Email"
                                    labelWithAsterisk={true}
                                    type="email"
                                    id="email"
                                    onChange={e => validateEmail(e)}
                                    erro={erroEmail}
                                    onBlur={(e) => validaEmail(e.target.value)}
                                    isValid={false}
                                    loading={false}
                                    marginBottom="32px"
                                    height="auto"
                                />

                                <Input
                                    name="whatsapp"
                                    value={whatsapp}
                                    type="text"
                                    label="Whatsapp"
                                    labelWithAsterisk={false}
                                    id="whatsapp"
                                    onChange={e => validateWhatsapp(e)}
                                    inputmode="numeric"
                                    erro={erroWhatsapp}
                                    marginBottom="46px"
                                    height="auto"
                                />

                                <S.ContainerSelect>
                                    <Select 
                                        label="Loja"
                                        labelWithAsterisk={true}
                                        options={lojas}
                                        id="agro_subsidiary_id"
                                        onChange={e => validateLoja(e)}
                                        buttonAddNew={true}
                                        onClickAddNew={() => openModalLoja()}
                                        erro={erroLoja}
                                        marginBottom="12px"
                                        height="auto"
                                    />
                                </S.ContainerSelect>

                                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px', marginBottom: '60px' }}>
                                    <Button 
                                        width='100%'
                                        height='50px'
                                        value='ADICIONAR'
                                        outline={false}
                                        disabled={loading}
                                        onClick={() => salvarUser()}
                                        loading={loading}
                                    />
                                </div>

                            </div>

                        </Container>
                    </UserContainer>
                        

                    <ModalLoja
                        title="Adicionar nova loja"
                        show={showModalLoja}
                        onHide={closeModal}
                        update={updateLoja}
                    />

                    <ModalAlert
                        show={showDisabledCad}
                        onHide={() => setShowDisabledCad(false)}
                        size='md'
                    >
                        <h4 style={{
                            fontSize: '16px',
                            textAlign: 'center'
                        }}>Limite de cadastros atingido!</h4>

                        <p style={{
                            textAlign: 'center',
                            marginTop: '20px',
                            fontSize: '13px',
                            letterSpacing: '0px'
                        }}>
                            Adquira mais licenças para adicionar novos responsáveis técnicos!
                        </p>

                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                            <Button
                                width='296px'
                                height='50px'
                                value='ADQUIRIR MAIS LICENÇAS'
                                outline={false}
                                disabled={false}
                                onClick={() => window.location = '/plano/edit'}
                                loading={false}
                            />
                        </div>
                    </ModalAlert>

                    {openModalAlert && (
                        <Modal
                            show={openModalAlert}
                            onHide={e => setOpenModalAlert(false)}
                            width='50%'
                        >
                            <S.ContainerWarning>
                                <img src={PeapleWarning} alt="Alerta" />

                                <H5 color={theme.colors.gray.Cinza_5}>E-mail já associado a outra conta</H5>

                                <BodyG color={theme.colors.gray.Cinza_5}>
                                    {mensagemModalAlert}
                                </BodyG>

                                <Button 
                                    width='151px'
                                    height='48px'
                                    value='Entendi'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => setOpenModalAlert(false)}
                                    loading={false}
                                />
                            </S.ContainerWarning>
                        </Modal>
                    )}
                </>
            )}
        />
    )


}

export default AddUsuario;